<div class="inline-block" data-test-id="ribbon">
	<div
		class="rounded-r-xs p-1.5 text-xs !leading-none font-semibold tracking-wider text-dark-primary uppercase ribbon md:p-2 md:text-sm"
	>
		{{ ribbonText() }}
	</div>
	<div
		class="size-0 border-r-[8px] border-b-[5px] border-solid ribbon-fold"
	></div>
</div>
